import { TimePicker } from '@blueprintjs/datetime';
import * as React from 'react';

import { isValidDate } from 'bones/utils/dates/isValidDate';
import {
  getDateFromXsdTimeString,
  getXsdTimeStringFromDate,
} from 'bones/utils/dates/xsdFormat';

export interface TimeInputProps {
  onSetValue: (value: string) => void;
  testId?: string;
  value: string | null;
}

export const TimeInput: React.VFC<TimeInputProps> = ({
  onSetValue,
  testId,
  value,
}) => {
  const date = getDateFromXsdTimeString(value || '');

  return (
    <div className="sd-input-time" data-testid={testId}>
      <TimePicker
        onChange={(date) => onSetValue(getXsdTimeStringFromDate(date))}
        useAmPm
        value={isValidDate(date) ? date : null}
      />
    </div>
  );
};
